import * as React from "react";

export default function SpdrText({
  SupplierGsdb,
  PlantGsdb,
  DockCode,
}: {
  SupplierGsdb: string | undefined;
  PlantGsdb: string | undefined;
  DockCode: string | undefined;
}) {
  return (
    <>
      {SupplierGsdb}-{PlantGsdb}-{DockCode}
    </>
  );
}
